export default {
  resetPasswordEmail: "重設密碼郵件",
  activeSuccess: "驗證成功，正在跳轉到登錄頁面",
  activingYourEmail: "正在驗證妳的郵件地址",
  addNewArticle: "投稿壹篇回憶",
  allEvents: "全部主題活動",
  alreadyActived: "已經驗證成功，正在跳轉到登錄頁面",
  alreadyBeenTaken: "已經被佔用了",
  alreadyRegistered: "這個郵件地址已經註冊過時光之冊了",
  back: "返回",
  backToHome: "返回主頁",
  bookNeedPassword: "需要密碼才能訪問這個紀念冊",
  bookSettings: "設置",
  cancel: "取消",
  changeAvatar: "修改頭像",
  changePassword: "修改密碼",
  clickToSignin: "點擊這裡直接登錄",
  code: "鏈接",
  commentDeleted: "該評論已刪除",
  createBookButton: "創建紀念冊",
  createNewBook: "創建新紀念冊",
  delete: "刪除",
  deleteArticleConfirm: "確定將這篇文章刪除嗎？",
  deleteArticleMessage: "刪除後將放入回收站，別人不再能看到",
  edit: "編輯",
  editArticleTitle: "編輯文章",
  editLink: "編輯分享鏈接",
  emailAddress: "郵件地址",
  emailNotFound: "這個郵件地址似乎從來沒有註冊過時光之冊",
  emailRegisteredButNotActived: "驗證郵件已發送至您的郵箱，等待驗證",
  emailSendSuccess: "郵件發送成功",
  empty: "妳忘了填寫",
  eventList: "全部主題活動",
  eventListTitle: "正在進行的主題活動",
  favorite: "贊",
  fileMaxSizeExceed: "最大上傳文件{size}KB",
  fileNumberSizeExceed: "最多只能上傳{number}個文件",
  uploadingFile: "還有文件正在上傳中，請稍候",
  findPasswordButton: "重置密碼",
  findPasswordTitle: "忘記密碼",
  forgotPassword: "忘記密碼？",
  Go: "Go",
  helloMessage: "Hi {email}, 開始之前，請先完善壹下個人資料",
  ifActiveEmailNotReceived: "沒收到驗證郵件嗎？",
  isAllowCoWrite: "是否允許您的朋友與您壹起創作？",
  isPublic: "是否公開",
  languageSelect: "語言",
  leaveComment: "留下妳的評論",
  linkCopied: "鏈接已經複製到剪貼板",
  linkToInviteCollaborators: "分享鏈接",
  mailSendFailed: "郵件發送失敗，請重試",
  mustWriteSth: "寫點什麼再發佈吧",
  newArticle: "妳的紀念冊有了新的文章？",
  newComment: "評論了妳的文章",
  newBook: "創建紀念冊",
  noContent: "文章中沒有內容",
  noNotice: "沒有新的消息",
  noSuchUser: "用護不存在",
  notAllowSpecialCharacters: "不能包含特殊字符",
  nothingToView: "沒找到妳要看的東西",
  notification: "通知",
  okStart: "OK Let's start!",
  onlyAcceptFileType: "只能上傳 {format} 格式的文件",
  pageNotFound: "沒有找到妳要看的內容",
  pageNotFoundDesp: "妳要訪問的地址現在不存在了，是不是輸入了錯誤的地址？",
  password: "密碼",
  passwordCorrect: "密碼驗證成功，正在為妳打開紀念冊",
  passwordNotSame: "兩次密碼輸入不壹致",
  passwordProtection: "需要密碼才能訪問",
  passwordResetSuccess: "密碼重置成功",
  postComment: "發佈評論",
  publishArticle: "發佈文章",
  randomPassword: "生成隨機密碼",
  resetPassword: "設置新密碼",
  retry: "重試",
  saveArticle: "保存文章",
  saveAsDraft: "暫存",
  saveAvatar: "保存頭像",
  saveBookChanges: "保存紀念冊",
  saveFailed: "保存失敗，請稍候重試",
  saveLink: "保存分享鏈接",
  saveUsername: "保存用護名",
  savePassword: "保存密碼",
  saveSuccess: "保存成功",
  seeAllNotification: "全部消息",
  setBookPassword: "設置訪問密碼",
  setNewPasswordTitle: "設置新密碼",
  setUsername: "設置用護名",
  settings: "帳護",
  signin: "登錄",
  signInTitle: "在這裡登錄",
  signInToSubmit: "登錄後可慘與創建，立刻登錄",
  signup: "註冊",
  signUpTitle: "在這裡註冊",
  signOut: "註銷",
  submit: "提交",
  submitClosed: "投稿已被作者關閉",
  title: "標題",
  tooLong: "不能大於{len}位",
  tooShort: "不能小於{len}位",
  typeBookPasswordHere: "請輸入訪問密碼",
  typeBookTitleHere: "在這裡輸入紀念冊標題",
  typeEmailHere: "請輸入郵件地址",
  typeNewCodeHere: "輸入新的code",
  typePassword: "請輸入密碼",
  typePasswordHere: "在這裡輸入密碼",
  typeValidEmail: "這似乎不是壹個有效的郵件地址",
  unFavorite: "取消贊",
  unicapsule: "時光之冊",
  updateProfile: "設置個人資料",
  uploadAvatar: "上傳頭像",
  uploadBookCover: "上傳封面圖片",
  uploadFailed: "上傳失敗，請稍候再試",
  views: "個查看",
  writeSthHere: "既然來了，留下些什麼吧",
  wrongAccessCode: "密碼錯誤",
  wrongPassword: "密碼錯誤",
  zoomIn: "查看",
  typeNewBookPasswordHere: "輸入新的訪問密碼",
  book: "紀念冊",
  eventEndAt: "主題活動結束時間",
  comment: "評論",
  commentBeenDeleted: "妳的評論已被刪除",
  authing: "正在驗證妳的帳護，請稍候",
  thirdPartyRegistered: "此郵件地址已經使用過 {provider} 註冊過了",
  or: "或者",
  thirdPartyLogin: "使用 {provider} 直接登錄",
  pleaseWait: "請稍候",
  repeatPasswordHere: "確認密碼",
  newPasswordLogin: "密碼重設成功，請使用新的密碼登錄",
  resetLinkExpired: "此鏈接已失效",
  avatar: "頭像",
  username: "用護名",
  copyLink: "複製鏈接地址",
  createdBook: "創建的紀念冊",
  joinedBook: "慘與的紀念冊",
  createdArticle: "創建的文章",
  favedBook: "贊過的紀念冊",
  favedArticle: "贊過的文章",
  deleteCommentConfirm: "確定要刪除這條評論嗎",
  deleteCommentMessage: "刪除後不可恢復",
  activeEmail: "驗證郵件",
  emailSent: "已發送至妳的郵箱",
  emailInstruction: "請按照郵件中的內容指示完成操作",
  emailSending: "正在發送，請稍候",
  clickHere: "點擊這裡",
  resendEmail: "重新發送",
  to: "  ",
  skipActivation: "郵件還沒收到？先進去看看吧，以後有空再驗證",
  activeEventList: "正在進行的主題活動",
  userNameDuplicated: "這名字不錯，可惜已經被註冊了。",
  networkError: "我們的服務器好像有故障了",
  serverCommunicateFaild:
    "在提交妳的請求時服務器可能開了壹點小差，為什麼不等壹等再試試呢",
  restPasswordInstruction1:
    "我們已給妳發送了壹封電子郵件，其中包含了重置密碼的說明。",
  restPasswordInstruction2:
    "請確保它沒有被過濾到妳的垃圾郵件裏。 如果妳沒有收到我們的密碼重置郵件，請刷新頁面後重試壹次。",
  articleNotSaved: "剛才寫的東西還沒保存呢",
  articleNotSavedMessage: "不保存壹下再退出嗎？",
  discard: "不要了",
  refresh: "刷新頁面",
  oldLinkVanished: "分享鏈接修改後，之前的鏈接將不能訪問",
  hasNewBook: "{number} 個新紀念冊",
  commentDeletedBy: "{name} 刪除了妳的評論",
  continueWithoutSign: "隨便看看",
  typeValidLink: "這似乎不是壹個有效的鏈接",
  link: "鏈接",
  insertLinkImgError: "下載該鏈接失敗",
  getPostionFailed: "獲取位置信息失敗，請稍候再試",
  getWeatherFaild: "獲取天氣信息失敗，請稍候再試",
  eventEndTip: "這個活動已經結束了，下次早點來吧",
  readMore: "繼續閱讀",
  widthOrigin: "原始寬度",
  rotateRight: "向右旋轉",
  rotateLeft: "向左旋轉",
  maxWidth: "寬度",
  pintop: "置頂",
  cancelPintop: "取消置頂",
  mineHome: "個人主頁",
  pullDownToRefresh: "下拉刷新數據",
  releaseToRefresh: "松開刷新數據",
  pullUpToLoad: "上拉加載數據",
  loadCompleted: "加載完畢",
  facebook: "facebook",
  weibo: "微博",
  wechatShare: "微信",
  emailShare: "郵件",
  openImage: "查看原圖",
  draftArticle: "草稿",
  googleLoginFailed: "谷歌登錄失敗，請用email註冊",
  advanceSetting: "高級設置",
  inviteFriends: "邀請好友參與",
  inviteFriendsPlaceholder: "輸入好友郵件地址",
  invatationLetter: "邀請信",
  cardStyle: "卡片樣式",
  typeBookIntroHere: "輸入紀念冊簡介（可選）",
  activeEmailSendSuccess: "激活郵件已發送",
  canUpload: "VIP用戶可上傳{number}張圖片",
  invatationLetterContent:
    "我在時光之冊創建了壹個紀念冊,跟我壹起紀念那些回憶吧",
  IndexPage: "首頁",
  LoginPage: "登錄",
  RegPage: "註冊",
  CreatePage: "創建新的紀念冊",
  EditBookPage: "修改紀念冊",
  EventPage: "活動",
  EventViewPage: "活動詳情",
  EventArticleListPage: "活動詳情",
  BookViewPage: "查看紀念冊",
  BookPage: "查看紀念冊",
  AddArticlePage: "添加回憶",
  HomeDefaultPage: "個人主頁",
  HomeCreatedBookPage: "我創建的紀念冊",
  HomeFavedBookPage: "我贊過的紀念冊",
  HomeJoinedBookPage: "我參與的紀念冊",
  HomeCreatedArticlePage: "我創建的回憶",
  HomeFavedArticlePage: "我贊過的回憶",
  HomeDraftArticlePage: "我的草稿",
  SettingPage: "個人資料設置",
  ProfilePage: "個人資料設置",
  EmailActivationPage: "郵件激活",
  ActivationPage: "激活",
  ArticleViewPage: "查看回憶",
  ArticleViewByBookPage: "查看回憶",
  ArticleEditPage: "編輯回憶",
  ForgotPasswordPage: "忘記密碼",
  ResetPasswordPage: "重設密碼",
  AuthPage: "認證中",
  AuthCallbackPage: "認證中",
  "404Page": "沒找到妳要看的",
  notFoundPage: "沒找到妳要看的",
  invite: "邀請好友",
  sendInvite: "發出邀請",
  cannotInviteYouself: "不能邀請自己",
  invaiteSendSuccessed: "邀請發送成功",
  inviteSuccessed: "邀請已成功發出",
  inviteFailedEmail: "郵件地址無效",
  management: "內容管理",
  HomeCreatedBook: "創建的紀念冊",
  HomeFavedBook: "贊過的紀念冊",
  HomeJoinedBook: "參與過的紀念冊",
  HomeCreatedArticle: "創建的回憶",
  HomeFavedArticle: "贊過的回憶",
  HomeDraftArticle: "草稿",
  privateBook: "加密的紀念冊",
  downloadQrcode:"保存图片",
  eventMemberSum: '已投稿 {sum} 篇文章',
  eventCountdown:'距离活动结束还有',
  eventOpenDateCountdown:'距离公开内容还有',
  event:'主题活动',
  eventArticleList:'查看主题活动文章',
  addNewArticleToEvent:'投稿'
};
